import axios from "@/axios/axios";

export default {
  namespaced: true,
  actions: {
    searchHistoryDownload(context, type) {
      var fileName = "검색이력.xlsx";

      if (type === "PRODUCT") fileName = "제품 검색이력.xlsx";
      else if (type === "PRODUCT") fileName = "서비스 검색이력.xlsx";

      return axios
        .post("/api/admin/searchHistry/excel", null, {
          params: {
            type: type,
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log("error: " + error);
          return Promise.reject(error);
        });
    },
    requestSearchHistorySubmit(context, payload) {
      return axios
        .post("/api/user/searchHistory/submit", null, {
          params: {
            categoryIdx: payload.categoryIdx,
            boardIdx: payload.boardIdx,
            type: payload.type,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
  },
};
